import BaseDataObject from './BaseDataObject';

export default class ResultOdds extends BaseDataObject {
  getOdds() {
    return this.getFloat('odds');
  }

  getCombination() {
    return this.getIntegerArray('combination');
  }

  getCombinationLength() {
    return this.getNumberOf('combination');
  }
}
